module.exports = __webpack_public_path__ + "img/SUMMERGATE_icon.a462388d.png";